import React from 'react';
import axios from 'axios';
import { Card, Button, Avatar,Modal,Spin } from 'antd';
import AccountUpdateForm from '../components/AccountUpdateForm'
import { UserOutlined,LoadingOutlined } from '@ant-design/icons';
import { PlusOutlined } from '@ant-design/icons';
import { Drawer,Divider } from 'antd';
import * as serverconfig from '../serverconn'
import {
  Col,
  Row,
} from 'reactstrap';
import { NavLink } from 'react-router-dom'


const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

var token= ''

class LoanApplicationDetails extends React.Component{

    state={
        account: {},
        datarequested:true,
    }


    componentDidMount(){
      if(localStorage.getItem("token")){
         token= localStorage.getItem("token")
      }else{
         token= ''
      }

      axios.defaults.headers={
        "Content-Type":"application/json",
        Authorization:`Token ${token}`
      }

        this.setState({datarequested:false})

    }





    render(){

      if(this.state.datarequested===true){
        return(
          <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
            
              <Spin  size="large">
                <div className="content" />
              </Spin>  

          </div>
        )
  
      }else{
        return(
          <div style={{display:'flex',flexDirection:'row',justifyContent:'space-evenly',flexWrap:'wrap'}}>

          {/**First coloumn */}
           <div>
           <p style={{display:'flex',flexDirection:'row',justifyContent:'space-between',flexWrap:'wrap'}}>
             <span style={{marginRight:5,fontWeight:'bolder'}}>Application Date: </span>
             <span>{this.props.application_record.submitted_at}</span> 
           </p>

          <p style={{display:'flex',flexDirection:'row',justifyContent:'space-between',flexWrap:'wrap'}}>
            <span style={{marginRight:5,fontWeight:'bolder'}}>Licence ID: </span>
            <span>{this.props.application_record.application_id}</span>
          </p>

          <p style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',flexWrap:'wrap'}}>
          <p> </p>
            <span style={{marginRight:5,fontWeight:'bolder'}}>Status:</span>
            <span>{this.props.application_record.status}</span>

          </p>


           </div>
          {/**second column */}
          <div>

          {
            JSON.parse(this.props.application_record.submitted_data).map((item)=>{
            return(
            <p style={{display:'flex',flexDirection:'row',justifyContent:'space-between',flexWrap:'wrap'}}>
              <span style={{marginRight:5,fontWeight:'bolder'}}>{item.label}: </span>
              <span>{item.field_type!="checkbox"?item.value:item.field_type==="checkbox"&&item.value===true?"Yes":"No"}</span>
            </p>
            )

           }) 
          }
          </div>

          {/**third column */}
          <div>
            {
              this.props.application_files.length>0?
                <div>
                  {
                  this.props.application_files.map((item)=>{
                    return(

                    <p style={{display:'flex',flexDirection:'row',justifyContent:'space-between',flexWrap:'wrap'}}>
                      <span style={{marginRight:5,fontWeight:'bolder'}}>{item.file_name}: </span>
                      <span>
                      <a href={`${item.file}`} target="_blank" download><span>Download</span></a>
                      </span>
                    </p>
                    )
                  })}
                </div>
                :
                null
              }

          </div>
          <Divider></Divider>
        </div>

      )}
       
    }
}

export default LoanApplicationDetails; 